<template>
	<v-app class="sign-in">
		<v-container class="fill-height pa-0" fluid>
			<v-row class="fill-height pa-0" no-gutters>
				<v-col cols="6" lg="7" class="fill-height" style="position:fixed" v-if="$vuetify.breakpoint.smAndUp">
					<v-img :src="img" class="fill-height"></v-img>
				</v-col>
				<v-col cols="12"
					   sm="6" offset-sm="6"
					   offset-lg="7" lg="5"
					   class="pa-0">
					<v-container fluid class="fill-height" style="position: relative; background-color: var(--v-white-base)">
						<v-row align="center" justify="center">
							<router-view :key="$route.meta?.key || $route.name"/>
						</v-row>
					</v-container>
				</v-col>
			</v-row>
			<div class="d-flex justify-end ma-0 pa-0">
				<rmp-alerts/>
			</div>
		</v-container>
	</v-app>
</template>

<script setup lang="ts">
import RmpAlerts from "@rmp/core/components/alerts/RmpAlerts.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";

const route = useRoute();

const img = computed(() => {
	switch (route.name) {
		case RouteNames.SIGN_IN:
			return "/img/images/sign-in-image.jpg";
		default:
			return "/img/images/auth-image.jpg";
	}
});
</script>
